import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <meta charSet="utf-8" />
    <meta name="theme-color" content="#F1B82D" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta
      name="description"
      content="University of Missouri Student's Underwater Robotics Foundation"
    />
    <title>MIZZOU SURF</title>
    <meta property="og:title" content="Mizzou SURF" />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://mizzousurf.com/" />
    <meta
      property="og:image"
      content="https://mizzousurf.com/images/underwaterTiger.jpg"
    />
    <meta
      property="og:description"
      content="Student's Underwater Robotics Foundation is a student organization that strives to implement the knowledge of engineering courses- utilizing them by manufacturing marine robotics projects. SURF is a competition team with an element of robotic research."
    />
    <link rel="shortcut icon" href="/favicon.ico" />
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
